{
  "meta": {
    "title": "TYCE",
    "description": "Custom description"
  },
  "global": {
    "skip": "Skip",
    "nextChapter": "Next chapter",
    "mute": "Mute",
    "unmute": "Unmute"
  },
  "header": {
    "back": "Exit the simulation",
    "presentation": "A day with <name>{{persona}}</name>"
  },
  "questions": {
    "summary": {
      "detail": "What I know about you ... You're a <tag>{{ relationship }}</tag> interest by <tag>{{ difference }}</tag>",
      "confirmation": "is that correct?",
      "yes": "Yes, let's start!",
      "no-back": "No, take me back",
      "no-start": "No, but let's start!"
    },
    "preliminary": {
      "relationship": {
        "question": "Hi, nice to meet you! \nBefore we begin, you are...",
        "educator": "an educator",
        "parent": "a parent",
        "child": "a kid!"
      }
    },
    "true": "True",
    "false": "False",
    "good": "Good",
    "neutral": "Neutral",
    "bad": "Bad",
    "likert": {
      "1": "Strongly agree",
      "2": "Agree",
      "3": "Neither",
      "4": "Disagree",
      "5": "Strongly disagree",
      "introduction": "Tell us how much you agree with the statements below.",
      "instruction": "Drag or click to answer",
      "drag": "Drag"
    },
    "aria": {
      "preliminary": {
        "heading": "Preliminary question",
        "instruction": "Click on one of the 3 possible following answers:"
      },
      "binary": {
        "heading": "True/False question {{step}} on {{max}}"
      },
      "likert": {
        "heading": "Likert question {{step}} on {{max}}",
        "instruction": "Choose one of the 5 possible anwers with eihter drag or click and then validate with the next button"
      },
      "feedback": {
        "heading": "Feedback question"
      }
    }
  },
  "tutorial": {
    "previous": "Previous",
    "skip": "Let's go",
    "next": "Next",
    "start": "Start",
    "aria": {
      "previous": "Show previous tutorial step",
      "next": "Show next tutorial step",
      "start": "Start the simulation",
      "pagination": "Step {{step}} on {{max}}"
    },
    "step-1": {
      "title": "How to <br/><color>move</color>",
      "description": "Use the left and right arrows on your\nkeyboard or fingers to move on the different lanes."
    },
    "step-2": {
      "title": "Catch <br/><color>bonus</color>",
      "description": "Lorem ipsum dolor sit amet consectetur. Penatibus convallis enim eget viverra in dignissim."
    },
    "step-3": {
      "title": "Catch <br/><color>bonus</color>",
      "description": "Lorem ipsum dolor sit amet consectetur. Penatibus convallis enim eget viverra in dignissim."
    },
    "step-4": {
      "title": "Avoid <br/><color>malus</color>",
      "description": "Lorem ipsum dolor sit amet consectetur. Penatibus convallis enim eget viverra in dignissim"
    }
  },
  "runner": {
    "play": "Play",
    "pause": "Pause",
    "next": "Next",
    "cta": "Let's go",
    "resume": "Resume",
    "exit": "Exit",
    "pause_screen": {
      "tag": "Pause",
      "title": "Time <br/><color>freeze</color>",
      "text": "It helps with concentration.",
      "sticker": "popin_freeze",
      "background": "background3",
      "color": "3"
    }
  },
  "summary": {
    "nav": "Summary navigation",
    "meet": {
      "title": "Meet \nanother child",
      "cta": "Meet {{persona}}"
    },
    "scroll": "Scroll to discover",
    "backToTop": "Back to the top",
    "title": "Summary",
    "click": "Click to see more",
    "highlight": "Simulation highlights",
    "drag": "Drag to explore"
  },
  "debug": {
    "popin": {
      "tag": "Item catched!",
      "title1": "Oh yeeesa <color>bonus</color>",
      "title2": "Oh nooo a <color>malus</color>",
      "title3": "Congrats an <color>achievement</color>",
      "text": "You’ll have to select the correct one!",
      "sticker": "magnifyingGlass",
      "cta": "Resume"
    }
  },
  "misc": {
    "alarm_clock": "Alarm clock",
    "cart": "Cart",
    "wallet": "Wallet",
    "freeze": "Freeze",
    "introMobile": {
      "label": "This site works best on desktop for the full experience.",
      "cta": "Next",
      "alt": "Desktop"
    },
    "intro": {
      "label": "Use headphones for better experience",
      "labelMobile": "Use headphones or activate the sound of your device for better experience",
      "cta": "Got it",
      "alt": "Headphones"
    }
  },
  "idle": {
    "title": "Choose persona",
    "text": "Select the simulation you want to run"
  }
}
